import axios from 'axios';

export const experiencesApi = {
  fetchExperiences(search) {
    return axios.get('/api/affiliate_portal/experiences', {
      params: {
        search,
      },
    });
  },
  fetchExperience(slug) {
    return axios.get(`/api/affiliate_portal/experiences/${slug}`);
  },

  // XXX move this probably
  fetchOrderHistory() {
    return axios.get(`/api/affiliate_portal/account/order-history`);
  },
};
